import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'compactClass' })
export class CompactClassPipe implements PipeTransform {
  transform(value: string[]): string[] {
    return value.filter(Boolean);
  }
}
